import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';

const Composite1 = ({ data }) => (
  <div className="composite__wrapper">
    <div className="composite" id="comp1">
      <div className="comp__image-wrapper" id="comp1-image1">
        <StaticImage
          src="../../assets/images/composite1-1.jpg"
          alt="This is the top left portion of a composite of four images that make up one image of a green chair in a library. This section contains the upper left portion of the chair, which sits next to a bookshelf filled with books. Behind the chair is a wall of bookshelves filled with colorful children’s books, labeled A and B in this portion of the image."
          width={900}
        />
      </div>

      <div className="comp__image-wrapper" id="comp1-image2">
        <StaticImage
          src="../../assets/images/composite1-2.jpg"
          alt="This is the top right portion of a composite of four images that make up one image of a green chair in a library. This section contains the upper right portion of the chair. Behind the chair is a wall of bookshelves filled with colorful children’s books, labeled C and D in this portion of the image. Some of the shelves contain children’s toys, such as dolls and a dinosaur. The book “Goodnight Moon” is given prominence on the uppermost shelf."
          width={900}
        />
      </div>

      <div className="comp__image-wrapper" id="comp1-image3">
        <StaticImage
          src="../../assets/images/composite1-3.jpg"
          alt="This is the bottom right portion of a composite of four images that make up one image of a green chair in a library. This section contains the bottom right portion of the chair. The chair rests on a textured, patterned carpet. In the foreground is a portion of a rug portraying the head of an elephant. Behind the chair is a wall of bookshelves filled with colorful children’s books."
          width={900}
        />
      </div>

      <div className="comp__image-wrapper" id="comp1-image4">
        <StaticImage
          src="../../assets/images/composite1-4.jpg"
          alt="This is the bottom left portion of a composite of four images that make up one image of a green chair in a library. This section contains the bottom left portion of the chair. The chair rests on a textured, patterned carpet. To the left of the chair is a bookshelf packed with books. Each book has a pink sticker on the spine above the white library sticker. In the foreground is a blurred portion of another chair."
          width={900}
        />
      </div>
    </div>
    <p className="benton-n4 composite__caption">{data.caption}</p>
  </div>
);

Composite1.propTypes = {
  data: PropTypes.shape({
    caption: PropTypes.string.isRequired,
  }).isRequired,
};

export default Composite1;
